import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { useState } from 'react';
import { Modal } from '@instructure/ui-modal';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { useStyle } from '@instructure/emotion';
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
/**
---
category: components/AI Components
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const DataPermissionLevels = ({
  modalLabel,
  title,
  data,
  closeButtonText,
  closeIconButtonScreenReaderLabel,
  currentFeature,
  currentFeatureText,
  triggerText,
  fullscreen = false
}) => {
  var _Heading, _Text;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const styles = useStyle({
    generateStyle,
    generateComponentTheme,
    componentId: 'DataPermissionLevels',
    displayName: 'DataPermissionLevels'
  });
  return _jsxs("div", {
    children: [_jsx(Link, {
      variant: "standalone",
      onClick: e => {
        e.preventDefault();
        setOpen(true);
      },
      forceButtonRole: false,
      href: "#",
      children: triggerText
    }), _jsxs(Modal, {
      size: fullscreen ? 'fullscreen' : 'medium',
      open: open,
      onDismiss: () => {
        setOpen(false);
      },
      label: modalLabel,
      shouldCloseOnDocumentClick: true,
      children: [_jsxs(Modal.Header, {
        spacing: "compact",
        children: [_jsx(Heading, {
          aiVariant: "stacked",
          children: title
        }), _jsx(CloseButton, {
          size: "medium",
          placement: "end",
          offset: "small",
          onClick: () => setOpen(false),
          screenReaderLabel: closeIconButtonScreenReaderLabel
        })]
      }), _jsx(Modal.Body, {
        children: _jsx("div", {
          css: styles === null || styles === void 0 ? void 0 : styles.body,
          children: data.map(({
            level,
            title,
            description,
            highlighted
          }, index) => _jsxs("div", {
            css: highlighted ? styles === null || styles === void 0 ? void 0 : styles.highlightedCard : styles === null || styles === void 0 ? void 0 : styles.card,
            children: [highlighted ? _jsxs("div", {
              css: styles === null || styles === void 0 ? void 0 : styles.currentFeature,
              children: [_Heading || (_Heading = _jsxs(Heading, {
                color: "primary-inverse",
                level: "reset",
                variant: "labelInline",
                children: [currentFeatureText, ' ']
              })), _Text || (_Text = _jsx(Text, {
                color: "primary-inverse",
                variant: "content",
                children: currentFeature
              }))]
            }) : null, _jsxs("div", {
              css: styles === null || styles === void 0 ? void 0 : styles.contentContainer,
              children: [_jsx("div", {
                css: styles === null || styles === void 0 ? void 0 : styles.level,
                children: level
              }), _jsx("div", {
                css: styles === null || styles === void 0 ? void 0 : styles.permissionTitle,
                children: _jsxs(Text, {
                  variant: "descriptionPage",
                  children: [title, " "]
                })
              }), _jsx(Text, {
                variant: "content",
                color: "secondary",
                children: description
              })]
            })]
          }, index))
        })
      }), _jsx(Modal.Footer, {
        children: _jsx(Button, {
          onClick: () => setOpen(false),
          children: closeButtonText
        })
      })]
    })]
  });
};
export default DataPermissionLevels;
export { DataPermissionLevels };